import { DISTRIBUTE_AI_BASE_URL } from '@/constants/distribute'

export type AppRouteView =
  | 'distribute'
  | 'follow'
  | 'messages'
  | 'placeholder'
  | 'profile'
  | 'search'
export type AppNavIconKey = 'discover' | 'follow' | 'messages' | 'search' | 'create' | 'me'

export interface AppRouteDefinition {
  key: string
  label: string
  path: string
  name: string
  title: string
  section?: string
  view: AppRouteView
  available: boolean
  iconKey: AppNavIconKey
  requiresAuth?: boolean
  externalUrl?: string
}

export const APP_TITLE_SUFFIX = '造梦次元'
export const APP_HOME_TITLE = `${APP_TITLE_SUFFIX} — 来造梦，造 100 种世界`
export const APP_DEFAULT_DESCRIPTION =
  '造梦次元 Dreama — AI 驱动的沉浸式创作平台，让每个参与者既是创造者也是世界的延续者。'
export const DEFAULT_APP_ROUTE = '/feed'
export const APP_BUILDING_MESSAGE = '构建中'
export const APP_NAV_MORE_LABEL = '更多'
export const APP_NAV_MORE_MESSAGE = '更多入口正在构建'

export const APP_ROUTE_DEFINITIONS: AppRouteDefinition[] = [
  {
    key: 'discover',
    label: '发现',
    path: '/feed',
    name: 'DiscoverView',
    title: '发现',
    view: 'distribute',
    available: true,
    iconKey: 'discover',
  },
  {
    key: 'follow',
    label: '关注',
    path: '/follow',
    name: 'FollowView',
    title: '我的关注',
    section: '我的关注',
    view: 'follow',
    available: true,
    iconKey: 'follow',
    requiresAuth: false,
  },
  {
    key: 'messages',
    label: '消息',
    path: '/messages',
    name: 'MessagesView',
    title: '消息',
    section: '消息',
    view: 'messages',
    available: true,
    iconKey: 'messages',
    requiresAuth: false,
  },
  {
    key: 'search',
    label: '搜索',
    path: '/search',
    name: 'SearchView',
    title: '搜索',
    section: '搜索',
    view: 'search',
    available: true,
    iconKey: 'search',
    requiresAuth: false,
  },
  {
    key: 'create',
    label: '创作',
    path: '/create',
    name: 'CreateView',
    title: '创作',
    section: '创作',
    view: 'placeholder',
    available: true,
    iconKey: 'create',
    externalUrl: DISTRIBUTE_AI_BASE_URL,
  },
  {
    key: 'me',
    label: '我的',
    path: '/mine',
    name: 'MeView',
    title: '我的',
    section: '我的',
    view: 'profile',
    available: true,
    iconKey: 'me',
    requiresAuth: false,
  },
]
